import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Pagination({ page, total, limit, onPageChange, testid = "pagination" }) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / (limit || 20)));
  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);
  if (total <= limit) return null;
  return (
    <div className="flex items-center justify-between px-1 py-3" data-testid={testid}>
      <div className="text-xs text-muted-foreground font-mono">
        {start}–{end} / {total}
      </div>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          data-testid={`${testid}-prev`}
          className="h-8 w-8 p-0"
          title="السابق"
        >
          <ChevronRight className="w-4 h-4" />
        </Button>
        <div className="px-3 py-1 text-sm font-mono bg-surface border border-border rounded-sm">
          {page} / {totalPages}
        </div>
        <Button
          variant="outline"
          size="sm"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          data-testid={`${testid}-next`}
          className="h-8 w-8 p-0"
          title="التالي"
        >
          <ChevronLeft className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
